import { Arrange, Text } from '@loomhq/lens';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RECORD_REPLY_SOURCE_VIDEO_END_SCREEN } from 'constants/sdk';

import { selectVideo } from 'selectors/shareVideo';
import { selectUserIsLogged } from 'selectors/user';
import {
  selectCommentsEnabled,
  selectEmojiEnabled,
  selectRecordReplyEnabled,
} from 'selectors/video';
import { selectIsMainVideoOnSharePage } from 'selectors/videoPlayer';

import RecordReplyFallbackButton from '../record-reply-fallback-button';
import { isSupported } from './stubs';

import CommentButton from 'components/ui-components/comment-button';
import EmojiReactionSet from 'components/ui-components/emoji-reaction-bar';

const PLAYER_WIDTH_THRESHOLD = 750;
const PLAYER_HEIGHT_THRESHOLD = 420;

const CommentRecordButtons = props => {
  const { compact } = props;

  const commentsEnabled = useSelector(selectCommentsEnabled);
  const isLoggedIn = useSelector(selectUserIsLogged);
  const isMainVideoOnSharePage = useSelector(selectIsMainVideoOnSharePage);
  const recordReplyEnabled = useSelector(selectRecordReplyEnabled);
  const [isSdkSupported, setIsSdkSupported] = useState(false);

  useEffect(() => {
    (async () => {
      const result = await isSupported();

      setIsSdkSupported(result.supported);
    })();
  }, []);

  const showRecordAReply =
    isLoggedIn && // Users must be authenticated, will revist: https://linear.app/loom-com/issue/PLFM-431/record-a-reply-for-anonymous-recording
    isMainVideoOnSharePage &&
    recordReplyEnabled &&
    isSdkSupported; // Checks if browser and cookie settings are compatible with loom-sdk

  return (
    <>
      {commentsEnabled && (
        <CommentButton
          fromEndScreen={true}
          tooltipPlacement="bottomCenter"
          buttonText={compact ? null : 'Comment'}
        />
      )}
      {showRecordAReply && (
        <div data-testid="record-reply-section">
          <RecordReplyFallbackButton
            compact={compact}
            iconButton="true"
            source={RECORD_REPLY_SOURCE_VIDEO_END_SCREEN}
          />
        </div>
      )}
    </>
  );
};

const ReactionCommentNudge = props => {
  const { width, height, fontSize } = props;
  const video = useSelector(selectVideo);
  const ownerName = video?.owner_name;
  const commentsEnabled = useSelector(selectCommentsEnabled);
  const emojiEnabled = useSelector(selectEmojiEnabled);

  const compact =
    emojiEnabled &&
    (width < PLAYER_WIDTH_THRESHOLD || height < PLAYER_HEIGHT_THRESHOLD);

  return (
    <Arrange
      data-testid="reaction-nudge-section"
      justifyContent="center"
      gap="2"
      autoFlow="row"
    >
      <Arrange justifyContent="center" gap="small">
        <Text size={fontSize} fontWeight="bold">
          Reply to {ownerName}:
        </Text>
      </Arrange>
      {emojiEnabled && (
        <Arrange justifyContent="center" gap="xsmall">
          <EmojiReactionSet fromEndScreen={true} />
          {compact && <CommentRecordButtons compact={true} />}
        </Arrange>
      )}
      {!compact && commentsEnabled && (
        <Arrange justifyContent="center" gap="medium">
          <CommentRecordButtons />
        </Arrange>
      )}
    </Arrange>
  );
};

export default ReactionCommentNudge;
